import {
  RECEIVE_USERLIST,
  RECEIVE_PLATELIST,
  RECEIVE_COMMONLIST,
  RECEIVE_ARTICLELIST,
  RECEIVE_LOGINUSER,
  RECORD_USERID,
  RECEIVE_PLATEUSERPLATELIST,
  RECEIVE_PLATEUSERARTICLELIST,
  RECEIVE_PLATEUSERCOMMONLIST,
  RECEIVE_PLATENAMES,
  RECEIVE_TOPLATEUSER
} from "./mutation-types"
import {setStore} from '../config/mUtils'
import state from './state'

export default {
  [RECEIVE_USERLIST](state,userList){
    state.userList = userList

  },
  [RECEIVE_TOPLATEUSER](state,toPlateUser){
    state.toPlateUser = toPlateUser

  },
  [RECEIVE_PLATELIST](state,plateList){
    state.plateList = plateList
  },
  [RECEIVE_PLATENAMES](state,plateNames){
    state.plateNames = plateNames
  },
  [RECEIVE_PLATEUSERPLATELIST](state,plateUserPlateList){
    state.plateUserPlateList = plateUserPlateList
  },
  [RECEIVE_COMMONLIST](state,commonList){
    state.commonList = commonList
  },
  [RECEIVE_PLATEUSERCOMMONLIST](state,plateUserCommonList){
    state.plateUserCommonList = plateUserCommonList
  },
  [RECEIVE_ARTICLELIST](state,articleList){
    state.articleList = articleList
  },
  [RECEIVE_PLATEUSERARTICLELIST](state,plateUserArticleList){
    state.plateUserArticleList = plateUserArticleList
  },
  [RECEIVE_LOGINUSER](state,loginUser){
    state.loginUser = loginUser
  },
  [RECORD_USERID](state,userId){
    if(userId!=""&&userId!="undefined"&&userId!=null){
      state.userId = userId;
      state.isLogin = true;
      setStore('bbs_user_id', userId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js